import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "p-2 rounded",
  style: {"display":"flex","flex-direction":"column","align-items":"stretch","justify-content":"space-between"}
}
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 576 512",
  style: {"min-width":"19px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--cor_indicadores_3)",
  d: "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "1em",
  viewBox: "0 0 512 512",
  style: {"min-width":"19px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  fill: "var(--cor_indicadores_3)",
  d: "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { style: {"overflow":"hidden","height":"100%"} }
const _hoisted_9 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleOpen && $setup.toggleOpen(...args))),
      class: "d-flex flex-row gap-3 align-items-center mb-3"
    }, [
      ($setup.isOpen)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
        : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7)),
      _createElementVNode("span", null, _toDisplayString($props.folderName), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("div", {
        id: $setup.isOut ? 'slot_folder_open' : 'slot_folder_closed',
        class: "ps-0 d-flex flex-column justify-content-between h-100"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_9), [
        [_vShow, $setup.isOpen]
      ])
    ])
  ]))
}